import React, { useState, useEffect } from "react";
import useStyles from "../styles";
import config from "../../../config";
import { useHistory } from "react-router-dom";

// components
import PageTitle from "../../../components/PageTitle/PageTitle";
import InputComponent from "../../partner/components/inputComponent";
import InputSelect from "../../partner/components/inputSelect";
import InputDecimal from "../../partner/components/inputDecimal";
import { CircularProgress } from "@material-ui/core";
import Modal from "../../modals/Modal";
import { Edit } from "@material-ui/icons";
import InputDisableSimpleText from "../../user/components/inputDisableSimpleText";
import SwitchHasCost from "../../user/components/switch";

export default function ServiceInfo() {
    const expressions = {
        usuario: /^[a-zA-Z0-9_-]{4,16}$/, // Letras, numeros, guion y guion_bajo
        nombre: /^[a-zA-ZÀ-ÿ\s]{1,40}$/, // Letras y espacios, pueden llevar acentos.
        password: /^.{4,12}$/, // 4 a 12 digitos.
        email: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
        numbers: /^[0-9]*$/, // 7 a 14 numeros.
        texto: /^[a-zA-Z0-9 ]{1,500}$/, // Letras
        textNumberAndSymbols: /^[a-zA-ZÀ-ÿ\sS&%'#+-@"!¡¿?()0-9._]+$/i
    }

    const classes = useStyles();
    let history = useHistory();

    const [baseUrl, setBaseUrl] = useState(config.config[0].baseUrl);
    const [serviceName, setServiceName] = useState({ text: '', valid: null });
    const [serviceCost, setServiceCost] = useState({ text: '', valid: null });
    const [serviceStatus, setServiceStatus] = useState({ text: '', valid: null });
    const [hasCost, setHasCost] = useState(false);
    const [hasCostFetch, setHasCostFetch] = useState(false);
    const [creationDate, setCreationDate] = useState('');
    const [lastUpdateDate, setLastUpdateDate] = useState('');

    const [serviceInfo, setServiceInfo] = useState([]);
    const [allStatus, setAllStatus] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingToSave, setIsLoadingToSave] = useState(false);
    const [disableInpunts, setDisableInpunts] = useState(true);
    const [showModal, setShowModal] = useState(false);

    const closeModalLogin = e => {
        setShowModal(false);
    }

    const fetchServiceInfo = async () => {
        var id = localStorage.getItem('serviceInfo');

        fetch(baseUrl + "servicesById/" + id,
            {
                headers: {
                    'Accept': 'application/json', 'Content-Type': 'application/json',
                    'Authorization': localStorage.getItem("token")
                },
            })
            .then(response => response.json())
            .then(data => {
                if (data != null) {
                    setServiceInfo(data);
                    setServiceName({ text: data.serviceName, valid: 'true' });
                    setServiceCost({ text: data.serviceCost, valid: 'true' });
                    setServiceStatus({ text: data.serviceStatus, valid: 'true' });
                    setHasCost(data.hasCost == 1 ? true : false);
                    setHasCostFetch(data.hasCost == 1 ? true : false);
                    setCreationDate(data.creationDate);
                    setLastUpdateDate(data.lastUpdateDate);

                    setIsLoading(false);
                } else {
                    setShowModal(true);
                }

                setIsLoading(false);
            })
            .catch(error => null);
    }

    const fetchStatus = async () => {
        if (!showModal) {
            fetch(baseUrl + "genericStatus",
                {
                    headers: {
                        'Accept': 'application/json', 'Content-Type': 'application/json',
                        'Authorization': localStorage.getItem("token")
                    },
                }).then(response => response.json())
                .then(data => {
                    if (data != null) {
                        setAllStatus(data);
                    } else {
                        setShowModal(true);
                    }
                }).catch(error => null);
        }
    }

    useEffect(() => {
        fetchServiceInfo();
        fetchStatus();
    }, []);

    const onSubmit = async e => {
        e.preventDefault();
        setIsLoadingToSave(true);

        if (serviceName.valid === 'true' && serviceStatus.valid === 'true') {
            const newService = {
                id: serviceInfo.id, serviceName: serviceName.text, serviceCost: hasCost == false ? '0.00' : serviceCost.text == '' ? '0.00' : serviceCost.text,
                serviceStatus: serviceStatus.text, hasCost: hasCost == true ? 1 : 0
            };

            const response = await fetch(baseUrl + "updateService", {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json', 'Content-Type': 'application/json',
                    'Authorization': localStorage.getItem("token")
                },
                body: JSON.stringify(newService)
            });
            const json = await response.json();
            if (json.message == "Ok") {
                setServiceName({ text: '', valid: null });
                setServiceCost({ text: '', valid: null });
                setServiceStatus({ text: '', valid: null });
            } else {
                if (json.message == "Access is denied") {
                    setShowModal(true);
                }
            }

            setDisableInpunts(!disableInpunts);
            setIsLoadingToSave(false);
        } else {
            setIsLoadingToSave(false);
        }
        fetchServiceInfo();
    }

    return (
        <div>
            {showModal ? (
                <Modal
                    isOpen={showModal}
                    closeModal={closeModalLogin}
                />
            ) : (
                <></>
            )}
            <div className={classes.titleRow}>
                <PageTitle title="Configuración" />
                {isLoading ? (
                    <></>
                ) : (
                    <>
                        <div className={classes.marginAuto} />
                        <div className={classes.divActionButton} >
                            <Edit classes={{ root: classes.searchIcon }}
                                onClick={() => {
                                    setDisableInpunts(!disableInpunts);
                                }}
                            />
                        </div>
                    </>
                )}
            </div>

            <div className={classes.divAddPage} >
                <div className={classes.divTitle}>
                    <label className={classes.titleStyle}>Información del servicio</label>
                </div>

                {isLoading ? (
                    <CircularProgress size={26} className={classes.loginPage} />
                ) : (
                    <>
                        <div className={classes.divColumn} >
                            <InputComponent
                                text={serviceName}
                                setPartnerCode={setServiceName}
                                type="text"
                                label="Nombre"
                                name="name"
                                regularExpression={expressions.textNumberAndSymbols}
                                placeholder="Nombre"
                                isEnable={disableInpunts}
                            />

                            <SwitchHasCost
                                value={hasCost}
                                setValue={setHasCost}
                                label="¿Tiene costo?"
                                isEnable={disableInpunts}
                            />

                            {hasCost ? (
                                <InputDecimal
                                    text={serviceCost}
                                    setPartnerCode={setServiceCost}
                                    type="text"
                                    label="Costo"
                                    name="price"
                                    placeholder="100.00"
                                    isEnable={disableInpunts}
                                />
                            ) : (
                                <></>
                            )}

                            <InputSelect
                                text={serviceStatus}
                                setValue={setServiceStatus}
                                label={"Estatus"}
                                options={allStatus}
                                isEnable={disableInpunts}
                            />

                            <InputDisableSimpleText
                                value={creationDate}
                                type="text"
                                label="Fecha de alta"
                                name="creationDate"
                                placeholder="Fecha"
                                isPrice={false}
                            />

                            <InputDisableSimpleText
                                value={lastUpdateDate}
                                type="text"
                                label="Última modificación"
                                name="lastUpdateDate"
                                placeholder="Fecha"
                                isPrice={false}
                            />
                        </div>
                    </>)}

                {disableInpunts ? (
                    <br />
                ) : (
                    <div className={classes.divButton}>
                        {isLoadingToSave ? (
                            <div className={classes.loginLoader} >
                                <CircularProgress size={26} />
                            </div>

                        ) : (
                            <button
                                className={serviceName.text != serviceInfo.serviceName || serviceCost.text != serviceInfo.serviceCost ||
                                    serviceStatus.text != serviceInfo.serviceStatus || hasCost != (hasCostFetch == 1 ? true : false) ?
                                    classes.enableButton : classes.disableButton}
                                disabled={!(serviceName.text != serviceInfo.serviceName || serviceCost.text != serviceInfo.serviceCost ||
                                    serviceStatus.text != serviceInfo.serviceStatus || hasCost != (hasCostFetch == 1 ? true : false))}
                                onClick={onSubmit}
                            >Guardar</button>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}
